export const getCleanUrl = (path: string): string | undefined => {
  let url = null

  try {
    url = new URL(path)
  } catch (e) {
    return undefined
  }

  return url.origin + url.pathname
}
